import React from "react";
import { FieldHeading } from "./FieldHeading.js";

type Props = {
  vatTotal: number;
};

/**
 * Generates table rows for the VAT report field 4.
 */
export const VatReportField4 = ({ vatTotal }: Props) => {
  return <FieldHeading label="Väli 4" description="Käibemaks kokku" total={vatTotal} itemsCount={0} />;
};
